// JS for All Projects Block.
// Mobile and desktop filter interactivity and functionality.

$(window).on('load', function() {
	if ($window.width() < breakpoint) {
		filter_closed_h		= $filter_ui.height();
		filter_open_h		= $filter_ui.height() + $filter_menu.height() - 38;
	}

    initFilter();
	
	// $('.chip').hide();
	// updateChipLayout();
	// $('.chip').fadeIn(300);
	$('.chip').fadeOut(0, updateChipLayout).delay(100).fadeIn(300);

	initResizeWatcher();
})

let
	$window 			= $(window),
	breakpoint 			= 992,
	prevWidth,
	$filter_ui 			= $('.filter-ui'),
	$filter_btn 		= $('.filter-btn'),
	$filter_menu 		= $('.filter-menu'),
	$filter_item 		= $('.filter-menu__item'),
	filter_closed_h,
	filter_open_h;

function initResizeWatcher() {
	console.log('ALL PROJECTS: initResizeWatcher()');
    $window.on('resize', function() {
        if ($window.width() >= breakpoint) {
			// Mobile to desktop.
			if (prevWidth < breakpoint) {
				filter_closed_h		= '';
				filter_open_h		= '';
				$filter_ui.css('height',filter_closed_h);
			}
		} else {
			// Desktop to mobile.
			if (prevWidth >= breakpoint) {
				filter_closed_h		= $filter_ui.height();
				filter_open_h		= $filter_ui.height() + $filter_menu.height() - 38;
				if ($filter_btn.hasClass('open')) {
					$filter_ui.css('height',filter_open_h);
				} else {
					$filter_ui.css('height',filter_closed_h);
				}
			}
		}
		prevWidth = $window.width();
    });
}

function initFilter()  {
	console.log('ALL PROJECTS: initFilter()');

	// On load .filter-menu is rendered so that JS can grab height.
	$filter_menu.hide();
	$filter_menu.css('opacity','1'); // opacity:0 set in CSS.
	// On load height of .filter-ui is read and set via inline CSS.
	$filter_ui.css('height',filter_closed_h);

	// URL may have filter(show) query var. Value is Term slug.
	var urlParams = new URLSearchParams(window.location.search);
	var my_filter = urlParams.get('show');

	// When filter item is clicked, reload page with filter applied.
	$filter_item.each(function() {
		// $my_item = $(this);
		$(this).on('click', function() {
			if ($(this).hasClass('active')) {
				// $(this).removeClass('active');
			} else {
				$filter_item.removeClass('active');
				$(this).addClass('active');

				// On click, hide all chips, show chips with selected filter slug value as class.
				my_filter = $(this).data('filter');
				$('.chip').hide();
				$('.chip').removeClass('filtered');
				$('.chip.'+my_filter).addClass('filtered');

				updateChipLayout();

				$('.chip.'+my_filter).fadeIn(300);

				// Update selected filter text (visible on filter close).
				var my_filter_name = $(this).text();
				$filter_btn.text(my_filter_name);

				// // On click, get selected filter slug value, construct query string, load new URL.
				// my_filter = $(this).data('filter');

				// // Construct new URL with year query string.
				// var filtered_page = '//' + window.location.host + window.location.pathname + '?show=' + my_filter;
				// filtered_page = filtered_page.replace(/page\/\d+\/?/, '');
				// window.location.href = filtered_page;
			}	
		});
	});

	// To open filter menu, add .open to .filter-menu.
	$filter_btn.on('click', function() {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			if ($window.width() < breakpoint) {
				$filter_menu.slideUp(300);
				$filter_ui.css('height',filter_closed_h);
			} else {
				$filter_menu.fadeOut(300);
			}
		} else {
			$(this).addClass('open');
			if ($window.width() < breakpoint) {
				$filter_menu.slideDown(300);
				$filter_ui.css('height',filter_open_h);
			} else {
				$filter_menu.fadeIn(300);
			}
		}
	});

}

function updateChipLayout() {
	console.log('ALL PROJECTS: updateChipLayout()');

	var $chips_container 	= $('.section-all-projects__left.projects');
	var $chips_visible 		= $('.chip.filtered');
	// Count rows of chips and use to set desktop aspect ratio of .section-all-projects__left via inline CSS.
	var my_chip_count 		= $chips_visible.length;
	var my_chip_row_count 	= Math.ceil(my_chip_count/2);

	// If even number of projects, use ROW_COUNT x 800 + 333 for height in aspect ratio.
	// If odd number of projects, use ROW_COUNT x 800 for height in aspect ratio.
	var my_aspect = 1170/((my_chip_row_count * 800) + (((my_chip_count + 1)%2) * 333));
	// 11 projects --> aspect-ratio:0.24375;

	// Force aspect down one hundred thousandth to compensate for imperfect math beginning at my_chip_count = 14.
	my_aspect = my_aspect - 0.00001;


	// Set margin for first chip in second column of mobile flex layout.
	$chips_visible.css('margin-top','');
	$chips_visible.eq(my_chip_row_count).css('margin-top','calc((333/1170)*100%)');
	// if ($index == ($my_project_row_count + 1)) {
	// 		$my_inline_css 	.= 'margin-top:calc((333/1170)*100%);';
	// }

	$chips_container.css('aspect-ratio', my_aspect.toString());
}